import { FormBuilder } from "components/FormBuilder/FormBuilder"
import React from 'react'
import { useTranslation } from "react-i18next";

/**
 * @param {Object} props 
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderSelectionOptionsType[]} props.salesOptions
 * @param {import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderSelectionOptionsType[]} props.referrerOptions
 * @param {boolean} props.isCreate
 * @param {boolean} props.isEditing
 * @param {boolean} props.isLoading
 */
const OnlineMerchantManagementOtherSection = ({
  formProps,
  salesOptions,
  referrerOptions,
  isCreate,
  isEditing,
  isLoading
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.merchant.otherSection" });
  const { t: tCommon } = useTranslation();

  const isDisabled = isLoading;
  const isReadOnly = !isCreate && !isEditing;

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    sales: {
      fieldType: "selection",
      fieldName: "sales",
      label: tLocal("label.sales"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        options: salesOptions,
      }
    },
    referrer: {
      fieldType: "selection",
      fieldName: "referrer",
      label: tLocal("label.referrer"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        options: referrerOptions,
      }
    }
  }

  return (
    <FormBuilder.Section
      title={tLocal("title")}
      titleVariant="h3"
    >
      <FormBuilder.Row itemsPerRow={2}>
        {
          FormBuilder.buildFields({
            formProps,
            t: tCommon,
            fields: [
              fieldsConfig.sales,
              fieldsConfig.referrer
            ]
          })
        }
      </FormBuilder.Row>
    </FormBuilder.Section>
  )
}

export default OnlineMerchantManagementOtherSection